import React from 'react';
import { GroupedBarChart } from "@carbon/charts-react";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { transformToGroupValue, buildXYChartOptions, buildColorScale } from "../chartHelpers";

const Index = ({chart}) => {
    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData) => {
                const data = transformToGroupValue(panelData, chart);
                const colorScale = buildColorScale(data);
                const options = {
                    ...buildXYChartOptions(chart),
                    color: { scale: colorScale }
                };
                return <GroupedBarChart options={options} data={data} />;
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
